/**
 * Translate description: Filter component
 */

import { Fragment, useContext } from 'react';

import { useLanguageContext } from "../../context/LanguageContext";
import AppContext from '../../context/AppContext';

import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Select from '@mui/joy/Select';
import Option from '@mui/joy/Option';

export default ({ name, title, values = {} }) => {
  const { t } = useLanguageContext();
  const { filter, setFilter, setPaginator } = useContext(AppContext);
  return (
    <Fragment>
      <FormControl size="sm">
        <FormLabel>{title}</FormLabel>
        <Select
          value={filter[name]?.value ?? ''}
          size="sm"
          placeholder={`${t('Filter by')} key`}
          slotProps={{
            button: { sx: { whiteSpace: 'nowrap' } },
            listbox: { placement: 'bottom-end' },
          }}
          onChange={(e, v) => {
            if (!e) return;
            if (v) {
              setFilter({ ...filter, [name]: { value: v } });
            } else {
              let _f = filter;
              if (_f[name]) delete _f[name];
              setFilter({ ..._f });
            }
            setPaginator({ currentPage: 1 });
          }}
        >
          <Option value="">{t('All')}</Option>
          {Object.entries(values).map(([k, v]) => (
            <Option key={k} value={k}>{v}</Option>
          ))}
        </Select>
      </FormControl>
    </Fragment>
  )
};
